import { ExperienceSkillNormalized } from 'src/models/verifications/verification.models';
import { OverlayTriggerWrapper } from 'src/ui/shared/components/bootstrap/overlay/OverlayTriggerWrapper';
import { ExperienceSkillRankDisplay } from './ExperienceSkillRankDisplay';
import { Button } from 'react-bootstrap';

interface Props {
    normalized: ExperienceSkillNormalized;
}

export const VerificationSkillDisplay = ({
    normalized: { skill, experienceSkill },
}: Props): React.ReactElement => {
    return (
        <>
            <OverlayTriggerWrapper
                id={`tooltip-skill-${skill.id}`}
                trigger="focus"
                tooltip={
                    <div>
                        {skill.description || (
                            <span className="font-italic">No description provided</span>
                        )}
                    </div>
                }
            >
                <Button variant="link" className="text-black p-0">
                    <span className="mr-2">{skill.name}</span>
                </Button>
            </OverlayTriggerWrapper>
            <span className="mr-2">
                <ExperienceSkillRankDisplay experienceSkill={experienceSkill} />
            </span>
        </>
    );
};
